var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.done)?_c('div',{staticClass:"padding-bottom-100"},[(_vm.type === 'ok')?_c('div',[_vm._t("default")],2):_c('vip-check-button',{attrs:{"check":{msg:_vm.msg,type:_vm.type,data:_vm.data},"price":0,"title":"","pay-title":"购买政策标准详情","pay-sub-title":"政策标准详情金额","type":"policy"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }